<template>
  <td>
    <component
      :is="renderComponent"
      class="mr-1"
      v-for="link in links"
      :key="link"
      :to="'/dialogkontrolle/' + link"
    >
      {{ link }}
    </component>
    <v-button class="btn btn-primary" @click="showModal">
      Alle Dialoge anzeigen
    </v-button>
    <circular-mail-dialog-modal
      :show.sync="show"
      v-bind="model"
    ></circular-mail-dialog-modal>
  </td>
</template>

<script lang="babel">
import CircularMailDialogModal from "@/components/modals/CircularMailDialogModal";
export default {
  components: {
    CircularMailDialogModal
  },
  props: ['content', 'model'],
  data() {
    return {
      show: false
    };
  },
  methods: {
    showModal() {
      this.show = true;
    }
  },
  computed: {
    renderComponent() {
      if (!this.$route) {
        return "span";
      } else {
        return "router-link";
      }
    },
    links() {
      if (Array.isArray(this.content)) {
        return this.content;
      } else {
        return [this.content];
      }
    }
  }
};
</script>
